import { createDynamicThunk } from ".";

export const getExpenseCodeListThunk = createDynamicThunk({
  typePrefix: "expenseCode/getExpenseCodeListThunk",
  endpoint: "/expense-code/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((expenseCode) => ({
      label: `${expenseCode?.costCode} - ${expenseCode?.name}`,
      value: expenseCode?._id,
    })) || [],
});

export const getProjectCodeListThunk = createDynamicThunk({
  typePrefix: "projectCode/getProjectCodeListThunk",
  endpoint: "/project-code/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((projectCode) => ({
      label: `${projectCode?.code} - ${projectCode?.companyName}`,
      value: projectCode?._id,
    })) || [],
});

export const getDepartmentListThunk = createDynamicThunk({
  typePrefix: "departments/getDepartmentListThunk",
  endpoint: "/departments/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((department) => ({
      label: `${department?.name} - ${department?.code}`,
      value: department?._id,
    })) || [],
});

export const getCurrencyListThunk = createDynamicThunk({
  typePrefix: "currency/getCurrencyListThunk",
  endpoint: "/currency/findAll",
  method: "POST",
  transformResponse: (response) => {
    const list = response?.response || [];

    const currencyDropdown = list.map((currency) => ({
      label: currency?.code,
      value: currency?._id,
    }));
    const currencyRates = list.reduce((acc, currency) => {
      acc[currency._id] = currency.currencyRateHistory || [];
      return acc;
    }, {});
    return { currencyDropdown, currencyRates };
  },
});

export const getUserListThunk = createDynamicThunk({
  typePrefix: "users/getUserListThunk",
  endpoint: "/users/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((user) => ({
      empID: user?.empID,
      empName: user?.name,
    })) || [],
});

export const getUserListWithDetailThunk = createDynamicThunk({
  typePrefix: "users/getUserListWithDetailThunk",
  endpoint: "/users/findAll",
  method: "POST",
  transformResponse: (response) => {
    return (
      response?.response?.map((user) => ({
        id: String(user?._id),
        empID: user?.empID,
        empName: user?.name,
        profilePicUrl: user?.profilePicUrl,
        email: user?.email,
        designation: user?.designation,
        departmentID: Array.isArray(user?.departmentID)
          ? user.departmentID.map((d) => d).join(", ")
          : user.departmentID,
        departmentCode: Array.isArray(user?.departmentCode)
          ? user.departmentCode.map((d) => d).join(", ")
          : user.departmentCode,
        expenseCatID: user?.expenseCatID,
        canSendExpenseRequest: user?.canSendExpenseRequest,
      })) || []
    );
  },
});

export const getCurrencyListDetailThunk = createDynamicThunk({
  typePrefix: "currency/getCurrencyListDetailThunk",
  endpoint: "/currency/findAll",
  method: "POST",
  transformResponse: (response) => {
    return (
      response?.response?.map((currency) => ({
        id: String(currency?._id),
        code: currency?.code,
        symbol: currency?.symbol,
        symbol_native: currency?.symbol_native,
        currencyRateHistory: currency?.currencyRateHistory,
      })) || []
    );
  },
});

export const getVendorListThunk = createDynamicThunk({
  typePrefix: "vendors/getVendorListThunk",
  endpoint: "/vendors/findAll",
  method: "POST",
  transformResponse: (response) => {
    return (
      response?.response
        ?.filter((vendor) => vendor?.status === "ACTIVE")
        ?.map((vendor) => ({
          label: vendor?.name,
          value: vendor?._id,
        })) || []
    );
  },
});
